import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import objectPath from "object-path";
import { toAbsoluteUrl } from "../../../_helpers";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { useSelector, shallowEqual } from "react-redux";
import { roles } from "../../../../app/config/config";
import { QuickUserToggler } from "../extras/QuiclUserToggler";

export function HeaderMobile() {
  const uiService = useHtmlClassService();

  const user = useSelector((state) => state.auth.user, shallowEqual);
  const role = parseInt(user.idRole);

  const layoutProps = useMemo(() => {
    return {
      headerLogo: uiService.getStickyLogo(),
      asideDisplay: objectPath.get(uiService.config, "aside.self.display"),
      headerMenuSelfDisplay:
        objectPath.get(uiService.config, "header.menu.self.display") === true,
      headerMobileCssClasses: uiService.getClasses("header_mobile", true),
      headerMobileAttributes: uiService.getAttributes("header_mobile"),
      headerMobileRoleClass:
      role === roles.agenteValderma
      ? "header-mobile-valderma"
      : role === roles.agenteRoypet
          ? "header-mobile-roypet"
          : role === roles.agenteRoydermal
            ? "header-mobile-royderml"
            : "header-mobile-global",
    };
    /*eslint-disable-next-line*/
  }, [uiService]);

  return (
    <>
      {/*begin::Header Mobile*/}
      <div
        id="kt_header_mobile"
        className={`${layoutProps.headerMobileRoleClass} header-mobile align-items-center ${layoutProps.headerMobileCssClasses}`}
        {...layoutProps.headerMobileAttributes}
      >
        {/*begin::Logo*/}
        {/* <Link to="/"> */}
          <img
            alt="logo"
            style={{ maxWidth: "165px" }}
            src={toAbsoluteUrl("/media/logos/logo-bianco.png")
              // role === roles.agenteValderma
              //   ? toAbsoluteUrl("/media/logos/valderma-logo-bianco.png")
              //   : role === roles.agenteRoypet
              //   ? toAbsoluteUrl("/media/logos/roypet-logo-bianco.png")
              //     : role === roles.agenteRoydermal
              //     ? toAbsoluteUrl("/media/logos/roypet-logo-bianco.png")
              //     : toAbsoluteUrl("/media/logos/global-logo-bianco.png")
            }
          />
        {/* </Link> */}
        {/*end::Logo*/}


        {/*begin::Toolbar*/}
        <div className="d-flex align-items-center">
          <QuickUserToggler />
          {layoutProps.asideDisplay && (
            <>
              {/*begin::Aside Mobile Toggle*/}
              <button
                className="btn p-0 burger-icon burger-icon-left"
                id="kt_aside_mobile_toggle"
              >
                <span />
              </button>
              {/*end::Aside Mobile Toggle*/}
            </>
          )}

          {layoutProps.headerMenuSelfDisplay && (
            <>
              {/*begin::Header Menu Mobile Toggle*/}
              {/* <button
                className="btn p-0 burger-icon ml-4"
                id="kt_header_mobile_toggle"
              >
                <span />
              </button> */}
              {/*end::Header Menu Mobile Toggle*/}
            </>
          )}

          {/*begin::Topbar Mobile Toggle*/}
          {/* <button
            className="btn btn-hover-text-primary p-0 ml-2"
            id="kt_header_mobile_topbar_toggle"
          >
            <span
              style={{ color: "white !important" }}
              className="svg-icon svg-icon-xl bi bi-white-fill"
            >
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} />
            </span>
          </button> */}
          {/*end::Topbar Mobile Toggle*/}
        </div>
        {/*end::Toolbar*/}
      </div>
      {/*end::Header Mobile*/}
    </>
  );
}
